import { Button, Switch } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import TaskPopup from "../Components/Popups/TaskPopup";
import { ADD_TASK, SET_COURSES, SET_LINKS } from "../Constants/reducerEvents";
// import Calendar from "./Home/Calendar";
import ScheduleTasks from "./Home/ScheduleTasks";
import Today from "./Home/Today";
import Upcoming from "./Home/Upcoming";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function Home() {
  const [editPopup, setEditPopup] = useState(false);
  const [clickedTask, setClickTasked] = useState(null);
  const [alignment, setAlignment] = useState("courses");

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
  const dispatch = useDispatch();
  const editTask = (task) => {
    setClickTasked(task);
    setEditPopup(true);
  };
  const submitNewTask = (task) => {
    if (task) {
      dispatch({ type: ADD_TASK, payload: task });
    }
    setEditPopup(false);
  };

  return (
    <div style={{ width: "100%" }}>
      <Today />

      <Button variant="contained" onClick={() => editTask({})}>
        New Task
      </Button>
      {/* <ToggleButtonGroup
        color="primary"
        value={alignment}
        exclusive
        onChange={handleChange}
        style={{ paddingLeft: "20px", paddingTop: "2px" }}
      >
        <ToggleButton value="courses">Courses</ToggleButton>
        <ToggleButton value="scheduler">Scheduler</ToggleButton>
      </ToggleButtonGroup> */}

      {alignment === "courses" ? (
        <Upcoming taskClicked={editTask} />
      ) : (
        <ScheduleTasks />
      )}
      <TaskPopup
        open={editPopup}
        onClose={submitNewTask}
        initialTask={clickedTask}
      />
    </div>
  );
}
